import { render, staticRenderFns } from "./checkScores.vue?vue&type=template&id=6b5fe654&scoped=true"
import script from "./checkScores.vue?vue&type=script&lang=js"
export * from "./checkScores.vue?vue&type=script&lang=js"
import style0 from "./checkScores.vue?vue&type=style&index=0&id=6b5fe654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5fe654",
  null
  
)

export default component.exports